import {
  IonButtons,
  IonTitle,
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonBackButton,
} from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { findMessages } from "../../store/locationShow/actions/findMessages";
import { findUserRoles } from "../../store/locationShow/actions/findUserRoles";
import { findOrganization } from "../../store/organizationShow/actions/findOrganization";
import { HeaderSection } from "./components/HeaderSection";
import { SegmentsSection } from "./components/SegmentsSection";

export const OrganizationShow: React.FC = () => {
  const dispatch = useDispatch();

  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findOrganization(id));
    dispatch(findUserRoles(id));
    dispatch(findMessages(id));
  }, [dispatch, id]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/suscriptores" />
          </IonButtons>
          <IonTitle>Suscriptor</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <HeaderSection />
        <SegmentsSection />
      </IonContent>
    </IonPage>
  );
};
